import { createAction, props } from '@ngrx/store';
import { ReservationValidationError } from 'src/app/models/reservation-errors';

export const SetSchedulerErrors = createAction(
  '[Scheduler] Set Scheduler Errors',
  props<{ errors: ReservationValidationError[] }>(),
);

export const SetSchedulerPrintView = createAction(
  '[Scheduler] Set Scheduler PrintView',
  props<{ printView: boolean }>(),
);

export const SetShowConsolidatedAppointments = createAction(
  '[Scheduler] Set ShowConsolidatedAppointments',
  props<{ showConsolidatedAppointments: boolean }>(),
);

export const SchedulerAppointmentsBound = createAction('[Scheduler] Appointments Bound');
